<template lang="pug">
  div.faq
    van-search(class="faq_search", v-model="search", show-action, :placeholder="this.$t('searchInput')", @search="onSearch")
      template(#action)
        div(@click="onSearch") {{$t('search')}}
    div.faq_content
      //- p(v-if="faqQuick.length === 0 && searching === 'searched'", class="search_null") 未查找到内容
      van-list(v-model="searchLoading", @load="searchLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
        van-cell(class='faq_cell', v-for="(i, k) in faqQuick", :key="k", :title="i.title", is-link, :id="i.id", @click="toContentPage(i)")
      //- van-collapse(v-model="activeName", accordion)
      //-   van-collapse-item(v-for="(item, key) in faqQuick", :key='key', :title="item.title", v-if="item.content.length > 0")
      //-     van-cell(class="faq_cell", v-for="(i, k) in item.content", :key="k", :title="i.title", is-link, :id="i.id", @click='toContentPage(i)')
    //- p.faq_tip 没有解决问题？
    //- p.faq_fb 联系客服人员（Facebook）
  //- <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  //- </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Faq',
  data(){
    return {
      searchLoading: false,
      finished: false,
      search: '',
      activeName: -1,
      faqQuick: [],
      badge: 0,
      pageNo: 1,
      loadStatus: true
    }
  },
  created(){
    this.search = this.$route.query.search
    this.loadStatus = true
    this.searchFaq({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      appId: this.appid,
      channelId: this.channelId,
      content: this.search,
      languageCode: this.lang,
      phoneModel: this.phoneModel,
      pageNumber: 1,
    })
  },
  methods:{
    ...mapActions('faq', ['getCategoryList', 'getFAQContentList', 'getNewMsgNo', 'searchFaq']),
    toContentPage(val){
        console.log(val)
        this.$router.push({
            path: '/faq/content',
            query: {
                id: val.id,
                status: val.status
            }
        })
    },
    toHistoryPage(){
        this.$router.push({
            path: '/faq/history'
        })
    },
    onSearch(){
      this.faqQuick = []
      this.loadStatus = true
      this.searchFaq({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        content: this.search,
        phoneModel: this.phoneModel,
        languageCode: this.lang,
        pageNumber: 1
      })
    },
    searchLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNo += 1
      this.searchFaq({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        content: this.search,
        phoneModel: this.phoneModel,
        languageCode: this.lang,
        pageNumber: this.pageNo
      })
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'appid', 'channelId', 'lang', 'phoneModel']),
    ...mapGetters('faq', ['errmsg', 'loadingCate', 'categoryList', 'loadingFC', 'faqContentList', 'loadingNO', 'msgNo', 'searchData', 'searching'])
  },
  mounted(){
    this.$watch('searching', val => {
      if(val === 'searched'){
        this.searchData.faqContentList.list.map(val => {
           this.faqQuick.push(val)
        })
        if(this.faqQuick.length == this.searchData.faqContentList.total){
          this.finished = true
        }
        this.loadStatus = false
        this.searchLoading = false
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.faq_content{
  margin: 10px;
}
.faq_search{
  margin-top: -20px;
}
.faq_cell{
  .van-cell__right-icon::before{
    content: '';
  }
}
.search_null{
  text-align: center;
}
.faq_tip{
  font-size: 12px;
  color: #000;
  text-align: center;
  margin-top: 32px;
  font-weight: 300;
  margin-bottom: 1px;
}
.faq_fb{
  font-size: 12px;
  color: #e60012;
  text-align: center;
  text-decoration:underline
}
.faq_hist_btn{
  width: 90%;
  left: 5%;
  padding: 15px;
}
</style>